module.exports = __webpack_public_path__ + "img/BYOCS_Icons_SDOH_Build_noBG.3b4a6378.png";